import { render } from "./checkView.vue?vue&type=template&id=22679708&scoped=true"
import script from "./checkView.vue?vue&type=script&lang=js"
export * from "./checkView.vue?vue&type=script&lang=js"

import "./checkView.vue?vue&type=style&index=0&id=22679708&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22679708"]])

export default __exports__